import React, { FC } from 'react'

import { IconPricePromiseProps } from './IconPricePromise.types'
import * as Styled from './styles/IconPricePromise.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPricePromise: FC<IconPricePromiseProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPricePromiseProps['size'],
  isResponsive = false,
}: IconPricePromiseProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='m29.5 20-7.962 8-3.038-3' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M41.14 19.672a6.397 6.397 0 0 1-.133 9.15 6.398 6.398 0 0 1-4.69 7.858 6.347 6.347 0 0 1-1.415 2.6 6.413 6.413 0 0 1-6.575 1.86 6.397 6.397 0 0 1-9.15-.133 6.398 6.398 0 0 1-7.857-4.69 6.347 6.347 0 0 1-2.6-1.414 6.413 6.413 0 0 1-1.86-6.575 6.397 6.397 0 0 1 .14-9.15 6.397 6.397 0 0 1 4.682-7.858 6.347 6.347 0 0 1 1.415-2.6 6.413 6.413 0 0 1 6.575-1.86 6.398 6.398 0 0 1 9.15.132 6.397 6.397 0 0 1 7.858 4.69c.966.26 1.857.745 2.6 1.415a6.413 6.413 0 0 1 1.86 6.575Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 37c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPricePromise
